import * as Types from "./../constants/TypeActions";

export const setTitle = (body) => {

  return (dispatch) => {
    const d = (result) => {
      return {
        type: Types.SET_TITLE,
        result,
      };
    };
    return dispatch(d(body));

  };


};

export const setKeyTabBottom = (body) => {

  return (dispatch) => {
    const d = (result) => {
      return {
        type: Types.SET_KEY_TAB_BOTTOM,
        result,
      };
    };
    return dispatch(d(body));

  };


};